import request from '@/utils/request'

// 查询省份列表
export function getProvinceList() {
  return request({
    url: '/sys/area/listProvince',
    method: 'get'
  })
}

// 根据省份ID查询城市列表
export function getCityListByProvinceId(provinceId) {
  return request({
    url: '/sys/area/listCity',
    method: 'get',
    params: { provinceId }
  })
}
